import { render, staticRenderFns } from "./SwitchCheckbox.vue?vue&type=template&id=50c96e3a&scoped=true&"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchCheckbox.vue?vue&type=style&index=0&id=50c96e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c96e3a",
  null
  
)

export default component.exports